<template>
<div class="navigation-bar">
    <div class="navigation-bar-container">
        <b-navbar :close-on-click="true" :active="true">
            <template slot="brand">
                <b-navbar-item href="/">
                    <img class="logo" alt="Vue logo" src="../assets/logo.png" />
                </b-navbar-item>
            </template>
            <template slot="start" v-if="usuario">
                <b-navbar-dropdown label="Proyectos" left collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/proyecto" v-if="activar('PROYECTOS')">Proyectos <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/empleado" v-if="activar('EMPLEADOS')">Empleados <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
                <b-navbar-dropdown label="Ordenes" left collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/pedidoItems" v-if="activar('PEDIDO_ITEMS')">Pedidos de compra <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/orden" v-if="activar('ORDENES_DE_COMPRA')">Ordenes de compra <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/orden/approve" v-if="activarOpcion('aprobarOrdenCompra')">Ordenes Pendientes <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/centroCosto" v-if="activar('CENTRO_DE_COSTOS')">Centros de Costo <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/caja" v-if="activar('CAJAS')">Cajas <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
                <b-navbar-dropdown label="Productos" left collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/producto" v-if="activar('PRODUCTOS')">Productos <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/proveedor" v-if="activar('PROVEEDORES')">Proveedores <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/marca" v-if="activar('MARCAS')">Marcas <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/unidad" v-if="activar('UNIDADES')">Unidades <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
                <b-navbar-dropdown label="Inventario" left collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/inventario" v-if="activar('INVENTARIO')">Inventario <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/transferencia" v-if="activar('TRANSFERENCIAS')">Transferencias <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/asignaciones" v-if="activar('ASIGNACIONES')">Asignaciones <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
                <b-navbar-dropdown label="Seguridad" left collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/usuario" v-if="activar('USUARIOS')">Usuarios <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
                <!-- <b-navbar-dropdown label="Ventas" left collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/cliente" v-if="activar('CLIENTES')">Clientes <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/productoVenta" v-if="activar('PRODUCTOS_VENTA')">Producto <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/ordenVenta" v-if="activar('ORDENES_VENTA')">Pedido <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
                <b-navbar-dropdown label="Operaciones" left collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/mixers" v-if="activar('MIXERS')">Mixers <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/vendedor" v-if="activar('VENDEDORES')">Vendedores <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" tag="router-link" to="/envios" v-if="activar('ENVIOS')">Despachos <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown> -->
            </template>
            <template slot="end" v-if="usuario">
                <b-navbar-dropdown :label="usuario.usu_nombre" right collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/user/change-password">Cambiar Contraseña <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" @click.prevent="logout()">Cerrar sesion <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
            </template>
        </b-navbar>
    </div>
</div>
</template>
<script>
import { UsuarioService } from "../rest"
import StoreAdapter from "../store/StoreAdapter"
import Acceso from "../util/acceso"
export default {
    name: "NavBar",
    data() {
        return {

        }
    },
    computed: {
        usuario() {
            return StoreAdapter.get(StoreAdapter.modules.UsuarioStore.getters.usuario)
        }
    },
    methods: {
        logout() {
            UsuarioService.logout()
        },
        activar(modulo) {
            return Acceso.activarModulo(modulo)
        },
        activarOpcion(opcion) {
            return Acceso.activarOpcion(opcion)
        }
    },

    mounted() {
        StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.loadUsuario)
        UsuarioService.checkAppVersion()
    }
}
</script>